import { acceptFileTypes } from '@shared/file-grants/uploadable-files'
import { ProcessedFile, processFile } from '../../../../utils/fileUtils'
import { useAttachmentStore } from '../../../../store'
import { useAddChatToast } from '../../../../store/toasts'
import { useRef } from 'react'
import { useTrackAddAttachment } from '../../../../hooks/attachments-hooks'

export const FileAttachmentHandler = () => {
  const { addFileAttachment } = useAttachmentStore()
  const addChatToast = useAddChatToast()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const trackAddAttachment = useTrackAddAttachment()

  const attachFile = ({ file, value, error }: ProcessedFile) => {
    if (error) {
      addChatToast({ message: error, type: 'error' })
      return
    }
    addFileAttachment(file, value)
    trackAddAttachment({ type: 'file', trigger: 'Attachments Menu' })
  }

  const onAddFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (files) {
      const promises = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        promises.push(processFile(file))
      }
      const processed = await Promise.all(promises)
      for (const attach of processed) {
        attachFile(attach)
      }
    }
    fileInputRef.current!.value = ''
  }

  return (
    <>
      <input
        type="file"
        id="file-attachment-handler"
        ref={fileInputRef}
        onChange={onAddFile}
        accept={acceptFileTypes}
        className="hidden"
        multiple
      />
    </>
  )
}
